import Vorfallmanagement from "./Vorfallmanagement";

const neuerVorfall: () => Vorfallmanagement.Vorfall = () => {
  const feststellung = new Date();
  const neuerVorfall: Vorfallmanagement.Vorfall.Neu = {
    Feststellung: feststellung,
    FristEnde: null,
    BegruendungVerspaetung: null,
    BeginnVorfall: feststellung,
    VorfallDauertAn: false,
    EndeVorfall: feststellung,
    BezeichnungVorfall: "",
    BeschreibungVorfall: "",
    KategorieBetroffeneDaten: [],
    KategorieBetroffenePerson: [],
    BesonderePersonenbezogeneDaten: null,
    BesondersSchutzwuerdigeDaten: null,
    AnzahlBetroffeneDaten: "",
    AnzahlBetroffenePersonen: "",
    FolgenSicherheitDatenverarbeitung: [],
    MoeglicheFolgenFuerPersonen: [],
    Schadenseintritt: null,
    SchadenseintrittBeschreibung: null,
    Risikobewertung: null,
    GetroffeneAbhilfeMassnahmen: "",
    GeplanteAbhilfeMassnahmen: "",
    GetroffeneMassnahmenVermeidung: "",
    GeplanteMassnahmenVermeidung: "",
    RechtlicheBeurteilungen: [],
    Aufgaben: [],
    Korrespondenzen: [],
    KonzerngesellschaftIds: [],
  };
  const restVorfall: Vorfallmanagement.Vorfall = {
    ...neuerVorfall,
    Uuid: null as any,
    Id: 0,
    Status: Vorfallmanagement.Vorfall.Status.InBearbeitung,
    StatusBearbeitungsId: 0,
    StatusBearbeitungTranslationKey: "",
    ErfasstBearbeiterId: 0,
    LaufendeNummer: 0,
    ErstellDatum: new Date(),
    Historie: [],
    LetzteBearbeitungDatum: new Date(),
    LetzterBearbeiterId: 0,
    LetzterBearbeiterName: "",
    NeueSachverhalte: [],
    HatNachmeldung: false,
    Abschliessbar: false,
    BegruendungAbschlussNachFristAblauf: null,
  };
  return restVorfall;
};

const vorfallZumTesten = () => {
  const feststellung = new Date();
  const neuerVorfall: Vorfallmanagement.Vorfall.Neu = {
    Feststellung: feststellung,
    FristEnde: null,
    BegruendungVerspaetung: null,
    BeginnVorfall: feststellung,
    VorfallDauertAn: true,
    EndeVorfall: null,
    BezeichnungVorfall: `Notfall #${("0000" + Vorfallmanagement.Utility.randomIntegerFromTil(0, 5001)).slice(-4)}`,
    BeschreibungVorfall: "Ein Notfall ist geschehen",
    KategorieBetroffeneDaten: [
      {
        ListeId: "ea051cd9-6b15-45b5-9f28-907c3687751b",
        ElementId: "70d573af-b8fb-4699-9927-0a7f4b6a9b6a",
        Freitext: null,
      },
    ],
    KategorieBetroffenePerson: [
      {
        ListeId: "5e9065a6-8f32-44c6-a6b2-5c0d36f2e225",
        ElementId: "73b0279a-5767-4a7f-9f5d-34f73284af8e",
        Freitext: null,
      },
    ],
    BesonderePersonenbezogeneDaten: null,
    BesondersSchutzwuerdigeDaten: null,
    AnzahlBetroffeneDaten: `${Vorfallmanagement.Utility.randomIntegerFromTil(0, 50)}`,
    AnzahlBetroffenePersonen: `${Vorfallmanagement.Utility.randomIntegerFromTil(0, 1500)}`,
    FolgenSicherheitDatenverarbeitung: [
      {
        ListeId: "1aec7685-2826-47b5-a42d-7cd18ebdb43c",
        ElementId: "50f66b48-de4d-40b2-85e4-f312de708ece",
        Freitext: null,
      },
    ],
    MoeglicheFolgenFuerPersonen: [
      {
        ListeId: "d98f909f-ba23-46d7-9564-0f1035489ed5",
        ElementId: "6d028a73-c217-4ee5-95dc-94d6ab3b9b37",
        Freitext: null,
      },
    ],
    Schadenseintritt: Vorfallmanagement.Vorfall.Schadenseintritt.Ja,
    SchadenseintrittBeschreibung: "Großer Schaden",
    Risikobewertung: null,
    GetroffeneAbhilfeMassnahmen: "",
    GeplanteAbhilfeMassnahmen: "",
    GetroffeneMassnahmenVermeidung: "",
    GeplanteMassnahmenVermeidung: "",
    RechtlicheBeurteilungen: [],
    Aufgaben: [],
    Korrespondenzen: [],
    KonzerngesellschaftIds: [],
  };
  const restVorfall: Vorfallmanagement.Vorfall = {
    ...neuerVorfall,
    Uuid: null as any,
    Id: 0,
    Status: Vorfallmanagement.Vorfall.Status.InBearbeitung,
    StatusBearbeitungsId: 0,
    StatusBearbeitungTranslationKey: "",
    ErfasstBearbeiterId: 0,
    LaufendeNummer: 0,
    ErstellDatum: new Date(),
    Historie: [],
    LetzteBearbeitungDatum: new Date(),
    LetzterBearbeiterId: 0,
    LetzterBearbeiterName: "",
    NeueSachverhalte: [],
    HatNachmeldung: false,
    Abschliessbar: false,
    BegruendungAbschlussNachFristAblauf: null,
  };
  return restVorfall;
};

const neueKorrespondenz = () => {
  return {
    Id: 0,
    KorrespondenzArtTranslationKey: "",
    KorrespondenzArt: Vorfallmanagement.Korrespondenz.Art.MeldungBehoerde,
    Datum: new Date(),
    BearbeiterName: "",
    Text: "",
    IsReadonly: false,
    Anhaenge: [],
    IsNewKorrespondenz: true,
    BenachrichtigungVon: null,
    BenachrichtigungBis: null,
    BenachrichtigungArten: [],
    BenachrichtigungSonstiges: null,
    ModifiedBydUserId: "",
  };
};

const neueLeitlinie = () => {
  const temp: Vorfallmanagement.Leitlinie = {
    Id: 0,
    Environment: "",
    LeitlinienStand: "14.12.2021",
    LeitlinienUrl: "https://edpb.europa.eu/system/files/2022-09/edpb_guidelines_012021_pdbnotification_adopted_de.pdf",
    LeitlinienUrlEn:
      "https://edpb.europa.eu/system/files/2022-01/edpb_guidelines_012021_pdbnotification_adopted_en.pdf",
  };
  return temp;
};

const VorfallmanagementDefaultDaten = {
  Vorfall: neuerVorfall,
  Korrespondenz: neueKorrespondenz,
  TestVorfall: vorfallZumTesten,
  Leitlinie: neueLeitlinie,
};

export default VorfallmanagementDefaultDaten;
